import React from 'react';
import PropTypes from 'prop-types';

import * as S from '../styles';

export function SadFace({ inactive, disabled }) {
    return (
        <S.SVGContainer $disabled={disabled} viewBox="0 0 1000 1000">
            <S.Background $active={!inactive } fill="#f15855" d="M543 43c252.4 0 457 204.6 457 457S795.4 957 543 957 86 752.4 86 500 290.6 43 543 43z" />
            <S.Shape fill="#353535" d="M656.2 707c-2.3 5.5-7.8 8.6-13.3 9.4-6.2 0-11.7-3.1-14.1-7.8-35.9-53.1-93.8-87.5-159.4-87.5S346 655.5 310.8 707.8c-3.1 5.5-8.6 8.6-14.1 7.8-6.2 0-10.9-3.9-13.3-9.4-2.3-5.5-1.6-11.7 2.3-16.4 39.1-60.2 107-100 183.6-100s144.5 39.8 185.2 100.8c3.3 4.7 4.1 11 1.7 16.4zm285.2-207c0-258.6-210.2-468.8-468.8-468.8S3.9 241.4 3.9 500s210.2 468.8 468.8 468.8S941.4 758.6 941.4 500zm-23.4 0c0 245.3-200 445.3-445.3 445.3S27.3 745.3 27.3 500s200-445.3 445.3-445.3S918 254.7 918 500z" />
        </S.SVGContainer>
    );
}

SadFace.propTypes = {
    inactive: PropTypes.bool,
    disabled: PropTypes.bool,
};

SadFace.defaultProps = {
    inactive: false,
    disabled: false,
};

export default SadFace;
